export default __webpack_public_path__ + "static/media/dinhat.e73ac1ac.jpg";